module.exports = __webpack_public_path__ + "assets/images/87b3b330cb734e4dbc5f0e1f72d1da4a.png";